module.exports = __webpack_public_path__ + "static/media/Emily02_full.3be9811f.png";